<template>
  <div class="account-troubleshooting-history">
    <!-- TODO uncomment when needed or remove if it is not-->
    <!-- <account-troubleshooting-pager
      :per-page="params.limit"
      @select="onChangeLimit"
      class="account-troubleshooting-history__pager"
    ></account-troubleshooting-pager> -->
    <div class="account-troubleshooting-history__header">
      <a href="/account/troubleshooting/" class="account-troubleshooting-history__reload">
        <i class="fas fa-sync-alt"></i>
      </a>
      <span class="account-troubleshooting-history__title">Import & Sync Troubleshooting</span>     
      <button class="bet btn-outline-primary" @click="onSort"><strong>Sort by Date</strong>        
        <i v-if="sort" class="fas fa-arrow-down"></i>
        <i v-else class="fas fa-arrow-up"></i>
        </button>
    </div>

    <snappy-loader v-if="loading" class="account-troubleshooting-history__loading"></snappy-loader>
      
    <template v-else>
      <template v-if="history.length">
        <sync-management-report           
          v-for="report in history"
          :key="report.id"
          :report="report"
          :troubleshooting="true"
          @clicked="$emit('trouble', report)"
        ></sync-management-report>
      </template>
      <div v-else class="account-troubleshooting-history__empty">No reports to show</div> 
    </template>

    <snappy-pagination
      :pagination="params"
      :records="history.length"
      :has-count="false"
      @paginate="onPaginate"
    ></snappy-pagination>      
    
  </div>
</template>

<script>
import SnappyPagination from '../../../components/SnappyPagination';
import SnappyDropdown from '../../../components/SnappyDropdown.vue';
import SyncManagementReport from '../../../components/sync/SyncManagementReport.vue';
import SnappyLoader from '../../../components/SnappyLoader';

const sortDirections = {
  Asc: 'asc',
  Desc: 'desc',
};

export default {
  name: 'account-troubleshooting-history',
  components: {    
    SnappyPagination,
    SnappyDropdown,
    SyncManagementReport,
    SnappyLoader
  },
  data() {
    return {      
      sort: false
    };
  },
  props: {
    history: {
      type: Array,
      required: true,
    },
    params: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean
    }
  },
  computed: {
    items() {
      let index = (this.params.page - 1) * this.params.size;
      return this.history.slice(index, index + this.params.size);
    },   
  },
  methods: {   
    onSort() {           
      this.$emit('sort', this.sort ? 'desc' : 'asc');
      this.sort = !this.sort;
    },
    onPaginate(page) {
      this.$emit('page', page);
    },
    // onChangeLimit(limit) {      
    //   this.$emit('limit', limit);
    //   if(limit >= this.params.total) {
    //     this.$emit('page', 1);
    //   }
    // }, 
  },
};
</script>

<style lang="scss">
@import '../../../../sass/web/_variables.scss';

.account-troubleshooting-history {
  &__pager {
    display: table;
    justify-content: flex-end;
    margin: 30px 0 16px;
  }
  &__header {
    background: $white-color;
    min-height: 80px;
    padding: 16px;
    border: 1px solid $platinum-color;
    display: grid;
    grid-template-columns: 48px 1fr;
    grid-template-rows: 1fr 1fr;
    gap: 20px;
    @media (min-width: $breakpoint-sm) {
      grid-template-columns: 48px 1fr max-content;
      grid-template-rows: 1fr;
    }
  }
  &__title {
    font-weight: 700;
    font-size: 24px;
    display: inline-flex;
    align-items: center;
    color: $mine-shaft-color;
  }
  &__reload {
    height: 48px;
    width: 48px;
    background: $mine-shaft-color;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    color: $white-color;
    font-size: 24px;
    text-decoration: none !important;
    &:hover {
      color: rgba($white-color, 0.8);
    }
  }  
  &__empty {
    height: 150px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__loading {
    margin: 50px auto;
  }
}
</style>
